import { SerializedStyles, css } from '@emotion/react';
import { Tabs as MuiTabs, TabsProps, styled } from '@mui/material';
import { FC } from 'react';

type Props = {
  indicatorType?: 'border' | 'underline';
} & TabsProps;

const StyledTabs = styled(MuiTabs, {
  shouldForwardProp: prop => prop !== 'indicatorType',
})<Props>`
  ${({ theme: { palette }, indicatorType = 'underline' }): SerializedStyles => css`
    & .MuiTab-root {
      min-height: 0;
      border: 1px solid ${palette.transparent.default};
    }

    ${indicatorType === 'border' &&
    `
      & .MuiTabs-indicator {
        display: none;
      }

      & .MuiButtonBase-root.Mui-selected {
        border-color: ${palette.primary.main};
        border-radius: 8px;
      }
    `}
  `}
`;
export const Tabs: FC<Props> = ({ indicatorType = 'underline', ...otherProps }) => (
  <StyledTabs indicatorType={indicatorType} data-testid={`indicatorType-${indicatorType}`} {...otherProps} />
);
